import { c as _c } from "react/compiler-runtime";
import { AdvisorProfileHubGate, AdvisorProfileLayout } from '@src/components/sco/Advisors/layout/AdvisorProfileLayout';
import { PayoutsSection } from '@src/components/sco/Advisors/sections/PayoutsSection';

/** `/advisors/profile/payouts` — Stripe Connect, balances, ledger, payout history. */
export const AdvisorProfilePayoutsSection = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AdvisorProfileHubGate><AdvisorProfileLayout compactHeader={true} activeKey="payouts" description="Connect Stripe to withdraw earnings. Booking still works before this is enabled." title="Payouts"><PayoutsSection /></AdvisorProfileLayout></AdvisorProfileHubGate>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};